import { useTranslation } from 'react-i18next';
import IncTextField from '../fields/inc-text-field/inc-text-field.component';
import TimezoneField from '../fields/timezone-field/timezone-field.component';
import AddressForm from '../address-form/address-form.component';
import { Box } from '@mui/material';
import { defaultAddressValueMap } from '../address-form/address-form.hooks';

const makeName = (name: string, prefix?: string) =>
  prefix ? `${prefix}.${name}` : name;

const WorkspaceForm = ({
  prefix = '',
  compact,
}: {
  prefix?: string;
  compact?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <IncTextField
        name={makeName('title', prefix)}
        label={t('forms.workspaceForm.fields.title.label')}
      />
      <IncTextField
        name={makeName('shortDescription', prefix)}
        label={t('forms.workspaceForm.fields.shortDescription.label')}
      />
      <IncTextField
        name={makeName('longDescription', prefix)}
        label={t('forms.workspaceForm.fields.longDescription.label')}
        multiline
        rows={5}
      />
      <IncTextField
        name={makeName('messageFromEmail', prefix)}
        label={t('forms.workspaceForm.fields.messageFromEmail.label')}
      />
      <AddressForm
        fieldNames={{
          city: makeName('address.city', prefix),
          country: makeName('address.country', prefix),
          postalCode: makeName('address.postalCode', prefix),
          region: makeName('address.region', prefix),
          streetAddress1: makeName('address.streetAddress1', prefix),
          streetAddress2: makeName('address.streetAddress2', prefix),
        }}
        regionIdKey="name"
        countryIdKey="name"
        usePlaceOptions={{
          addressValueMap: {
            ...defaultAddressValueMap,
            region: 'long_name',
            country: 'long_name',
          },
        }}
        compact={compact}
      />
      <TimezoneField name={makeName('timezone', prefix)} />
    </Box>
  );
};

export default WorkspaceForm;
